import React, { useState, useEffect, useMemo } from 'react';
import Markdownkatexnew from "./Markdown.js";
import axios from "axios"
import { isAuth } from '../helpers/auth';
import { ToastContainer, toast } from "react-toastify";
// import Tassk from './taskUser copy.js';
import Select, { components } from 'react-select';
import WindowFocusHandler from "./isvisible.js";
import Timer from './timer.js';
import { parseISO } from "date-fns";
import * as timeago from 'timeago.js';
import es from 'timeago.js/lib/lang/es';
timeago.register('es', es);



const ExportToExcel = ({ idtheme, codetheme, task_id, themetitle, unittitle }) => {
  const [value, setValue] = useState('')
  const [evaluacion, setEvaluacion] = useState("2")
  const [show, setShow] = useState(true)
  const [items, setItems] = useState([])
  const [taskss, setTaskss] = useState()
  const [datee, setDatee] = useState()
  const [dateb, setDateb] = useState()

  const [secondsRemaining, setSecondsRemaining] = useState(5)



  useEffect(() => {
    getTask()
  }, []);


  const getTask = async () => {
    fetch(`${process.env.REACT_APP_API_URL}/tasks/test/${idtheme}/${codetheme}/${isAuth()._id}`)
      .then((response) => response.json())
      .then(async (www) => {
        // console.log(www[0])
        if (www.length > 0) {
          setTaskss(www[0])
          setItems(www[0].items)
          setDateb(www[0].dateb)
          setDatee(www[0].datee)
          var encuestas = www[0].items
          var rptas = []
          if (encuestas.length > 0) {
            for (var j = 0; j < encuestas.length; j++) {
              if (encuestas[j].std === encuestas[j].rpta) {
                rptas.push(1)
              } else {
                rptas.push(0)
              }
            }
          }
          setEvaluacion(rptas.filter(x => x == 1).length)
        }
      })
  };

  const EndTest = async () => {
    if (window.confirm('Desea guardar y evaluar su test?')) {
      await axios.put(`${process.env.REACT_APP_API_URL}/tasks/test/${task_id}`, { datee: new Date() }).then((www) => {
        toast.success(www.data)
        getTask()
      }).catch((error) => { console.log("ERROR", error.response) })
    }
  }

  const sendTest = async (w, ww) => {
    await axios.put(`${process.env.REACT_APP_API_URL}/tasks/test/${task_id}`, { items: w, note: ww }).then((www) => {
      toast.success(www.data)
      // getTask()
    }).catch((error) => { console.log("ERROR", error.response) })
  }

  const onChange = (text) => (e) => {
    // console.log(items[text].alt)
    console.log(e.label[0], text);
    items[text].std = e.label[0]
    setItems(items)
    var encuestas = items
    var rptas = []
    for (var j = 0; j < encuestas.length; j++) {
      if (encuestas[j].std === encuestas[j].rpta) {
        rptas.push(1)
      } else {
        rptas.push(0)
      }
    }
    setEvaluacion(rptas.filter(x => x == 1).length)

    console.log(items)
    if (items != null) { sendTest(items, rptas.filter(x => x == 1).length) }
    // setFormData({ ...formData, [text]: e.target.value });
  }

  const MarkdownOption = (props) => {
    console.log(props.data.label)
    return (
      <components.Option {...props}>
        <Markdownkatexnew>{props.data.label[0]}</Markdownkatexnew>
      </components.Option>
    );
  };

  const MarkdownSingleValue = (props) => {
    console.log(props.data)
    return (
      <components.SingleValue {...props}>
        <Markdownkatexnew>{props.data.label[0]}</Markdownkatexnew>
      </components.SingleValue>
    );
  };

  const handleDataFromChild = (data) => {
    console.log(data)
    setShow(false);
  };

  const handleFromChild = (data) => {
    setSecondsRemaining(0)
    console.log(data)
    setShow(false);
  };

  // const options = [
  //   { value: 'bold', label: '**Bold** Option' },
  //   { value: 'italic', label: '*Italic* Option' },
  //   { value: 'code', label: '`Code` Option' }
  // ];

  // const MyDropdown = () => (
  //   <Select options={options} components={{ Option: MarkdownOption, SingleValue: MarkdownSingleValue }} />);


  return (
    <div>
      <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} newestOnTop={false} closeOnClick={true} rtl={false} pauseOnFocusLoss={false} draggable pauseOnHover={false} closeButton={false} />

      {taskss && isAuth().rol != '1' ?
        <>
          <div>
            {secondsRemaining === 0 ?
              <div className='text-center w-100'>
                <span className='text-center text-warning'>Culminó la evaluación {value} - {idtheme} {codetheme}</span><br />
                <span className='text-center text-info'>Crédito: {evaluacion}</span><br />
                {taskss.dateb} {taskss.datee}
              </div>
              :
              <>
                {show ? <>
                  <Timer endDate={datee} onFinish={handleFromChild} />
                  <WindowFocusHandler onDataReceived={handleDataFromChild} />
                  <div className='row justify-content-center align-items-center' style={{ margin: '.5em' }}>
                    {items.map((number, i) =>
                      <div key={i + 1} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 p-1">
                        <div className="p-1 bg-light rounded">
                          {/* {number.prg} */}
                          [{i + 1}]
                          <Markdownkatexnew className="text-black">
                            {number.prg}
                          </Markdownkatexnew>
                          <Markdownkatexnew className="text-info">
                            {number.std}
                          </Markdownkatexnew>
                          {number.alt.length > 1 ?
                            <Select onChange={onChange(i)} options={
                              number.alt.map((guest, index) => {
                                return {
                                  label: guest,
                                  value: guest,
                                  key: index
                                }
                              })
                            } components={{ Option: MarkdownOption, SingleValue: MarkdownSingleValue }} />
                            :
                            <textarea className="form-control" onChange={onChange(i)} required="required"></textarea>
                          }
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='text-center text-warning h5'>
                    <button type="submit" onClick={EndTest} className='btn btn-warning'>
                      Guardar y evaluar
                    </button>
                  </div>
                </> : <div className='text-center text-warning'>Mantener la ventana en foco (Actualiza solo esta vez)</div>}
              </>
            }
          </div>
          {/* <Timer startDate={taskss.dateb} endDate={taskss.datee} curse={taskss.curse} /> */}
        </>
        : ''}

    </div >
  );
};

export default ExportToExcel